import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDialogBody } from '../../components/DialogBody/DialogBody.styles';
import { StyledDialogFooter } from '../../components/DialogFooter/DialogFooter.styles';
import { StyledDialogHeader } from '../../components/DialogHeader/DialogHeader.styles';
import { StyledDialogLayout } from '../../components/DialogLayout/DialogLayout.styles';
import { StyledDropdownHeading } from '../../components/DropdownHeading/DropdownHeading.styles';
import { overflowAutoMixin } from '../overflowAutoMixin';
import { overflowPaddingMixin } from '../overflowPaddingMixin';
import { DialogMixin } from './DialogMixin';

/** @class DropdownMixin */
/**
 * Standalone styles for a dropdown component.
 *
 * @example
 * import { DropdownMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${DropdownMixin}
 * `;
 *
 * <Component>My dropdown component</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var DropdownMixin = function DropdownMixin(props) {
  return token({
    zIndex: 'Dropdown.zIndex',
    borderRadius: 'Dropdown.borderRadius',
    horizontalSpacing: 'Dropdown.horizontalSpacing',
    verticalSpacing: 'Dropdown.verticalSpacing',
    footerMargin: 'Dropdown.Footer.margin'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing,
      footerMargin = _ref.footerMargin,
      zIndex = _ref.zIndex;
    return css(["", " z-index:", ";border-radius:", "px;", "{display:flex;flex-direction:column;}", "{flex:0 0 auto;}", "{", " ", ";flex:1 1 auto;> ", "{margin-left:-", ";margin-right:-", ";&:first-child{margin-top:-", ";}}}", "{flex:0 0 auto;align-items:center;box-sizing:border-box;display:flex;justify-content:flex-end;margin:", "px;padding:", "px ", "px;}"], DialogMixin(props), zIndex, borderRadius, StyledDialogLayout, StyledDialogHeader, StyledDialogBody, overflowAutoMixin(props), overflowPaddingMixin(verticalSpacing + "px", horizontalSpacing + "px", verticalSpacing + "px"), StyledDropdownHeading, horizontalSpacing + "px", horizontalSpacing + "px", verticalSpacing + "px", StyledDialogFooter, footerMargin, verticalSpacing, horizontalSpacing);
  })(props);
};